import { withStyles } from '@material-ui/core';

import Moderation from './component';
import styles from './styles';

export default withStyles(styles)(Moderation);
